import React from 'react'
import { FeaturedLayout } from '../../layouts'
import PagosTab from './PagosTab'
import { useTemporadaActiva } from './useTemporadaActiva'
import TemporadaSelector from './TemporadaSelector'

const PagosRegistro = () => {
  const { temporadaId, temporadas, setTemporadaId } = useTemporadaActiva()

  return (
    <FeaturedLayout
      title="Pagos"
      subtitle="Libro de ingresos: el dinero que entró al club"
    >
      <PagosTab
        temporadaId={temporadaId}
        temporadaSelector={<TemporadaSelector temporadas={temporadas} value={temporadaId} onChange={setTemporadaId} />}
      />
    </FeaturedLayout>
  )
}

export default PagosRegistro
